import "./styles.scss";

import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useInvoices } from "context/client/invoices";
import MobileBar from "components/MobileBar";
import BackMobile from "components/BackMobile";
import Button from "components/Button";
import InvoiceFilters from "../../InvoiceFilters";

const mainClass = "invoices-modal-filters";
const initialFilters = { website: null, start_date: null, end_date: null };

const ModalFilters = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { filters, applyFilters, clearAllFilter } = useInvoices();
  const [draft, setDraft] = useState(initialFilters);
  const { website, start_date, end_date } = filters;

  useEffect(() => {
    if (isOpen) {
      setDraft({
        website: website || null,
        start_date: start_date || null,
        end_date: end_date || null,
      });
    }
  }, [isOpen, website, start_date, end_date]);

  useEffect(() => {
    const className = `${mainClass}-open`;
    document.body.classList.toggle(className, isOpen);
    return () => document.body.classList.remove(className);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  const isDirty = Object.keys(initialFilters).some(
    (name) => (draft[name] || null) !== (filters[name] || null),
  );
  const hasFilters = Object.keys(initialFilters).some(
    (name) => draft[name] || filters[name],
  );

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={mainClass}
          role="dialog"
          aria-modal="true"
          aria-label={t("Filter results")}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ type: "tween", duration: 0.2 }}
        >
          <MobileBar onWebsiteClick={onClose} />
          <div className={`${mainClass}__back`}>
            <BackMobile onClick={onClose} />
          </div>
          <div className={`${mainClass}__content`}>
            <InvoiceFilters
              values={draft}
              onChange={(name, value) =>
                setDraft((previous) => ({ ...previous, [name]: value }))
              }
            />
          </div>
          <div className={`${mainClass}__actions`}>
            <Button
              disabled={!hasFilters}
              onClick={() => {
                clearAllFilter();
                setDraft(initialFilters);
              }}
            >
              {t("Remove filters")}
            </Button>
            <Button
              disabled={!isDirty}
              onClick={() => {
                applyFilters(draft);
                onClose();
              }}
            >
              {t("Apply filters")}
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ModalFilters;